import { render, staticRenderFns } from "./GeneralInformationsTab.vue?vue&type=template&id=07720410&scoped=true"
import script from "./GeneralInformationsTab.vue?vue&type=script&lang=js"
export * from "./GeneralInformationsTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformationsTab.vue?vue&type=style&index=0&id=07720410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07720410",
  null
  
)

export default component.exports